import app from 'app';
import {
  ImageSpriteStyle,
  ColourCardSpriteStyle,
  SpriteStyle,
  TimePoint,
} from './grid';
import { point2time, invalidTime, isNumber } from './tapi';
import fg from '#/libs/FrameGrid';
import _ from 'lodash-extended';

function detectSprite(w, asset, useRTP) {
  if (
    useRTP &&
    asset.realTimePreviewResultData &&
    asset.realTimePreviewResultData.videoAssetStoryBoard &&
    asset.realTimePreviewResultData.videoAssetStoryBoard.links &&
    asset.realTimePreviewResultData.videoAssetStoryBoard.links[0]
  ) {
    w.sprite = asset.realTimePreviewResultData.videoAssetStoryBoard;
    w.time_0 = 0;
  } else if (
    asset.previewResultData &&
    asset.previewResultData.videoAssetStoryBoard &&
    asset.previewResultData.videoAssetStoryBoard.links &&
    asset.previewResultData.videoAssetStoryBoard.links[0]
  ) {
    w.sprite = asset.previewResultData.videoAssetStoryBoard;
    w.time_0 = asset.previewResultData.startTime; // time from the sprite beginning
  } else if (
    asset.metadata.videoAssetStoryBoard &&
    asset.metadata.videoAssetStoryBoard.links &&
    asset.metadata.videoAssetStoryBoard.links[0]
  ) {
    w.sprite = asset.metadata.videoAssetStoryBoard;
    w.time_0 = asset.startTime; // video fragment offset from original
  }
}

function detectImage(w, asset) {
  w.imageUrl =
    asset.thumbnail ||
    asset.metadata.thumbnail160x90Url ||
    asset.metadata.posterUrl ||
    asset.metadata.urlCdn ||
    asset.metadata.url ||
    null;

  if (app.assetType.isTWITTER(asset)) {
    w.imageUrl = app.TWITTER_PLACEHOLDER.URL;
  } else if (app.assetType.isFACEBOOK(asset)) {
    w.imageUrl = app.FACEBOOK_PLACEHOLDER.URL;
  } else if (app.assetType.isINSTAGRAM(asset)) {
    w.imageUrl = app.INSTAGRAM_PLACEHOLDER.URL;
  }

  // knowing the fixed item height, item width is calculated from ratio of original asset;
  // except for webpage where image thumbnail is autogenerated and his dimensions aren't specified - we
  // assume static wallpaper item width
  if (!app.assetType.isWEBPAGE(asset)) {
    if (asset.metadata.height > 0) {
      const ratio = asset.metadata.width / asset.metadata.height;
      w.item.width = ratio * w.item.height;
    }
  }
}

export function generateSpriteRectangles(
  timeRectangles,
  asset,
  rectangle,
  itemWidth,
  itemHeight,
  useRTP,
  colourCardCss
) {
  const rv = [];
  const w = {
    sprite: null,
    time_0: 0,
    item: {
      count: 0,
      width: itemWidth,
      height: itemHeight,
    },
  };

  detectSprite(w, asset, useRTP);

  if (w.sprite) {
    // render relevant image from sprite

    // knowing the fixed item height, item width is calculated from ratio of sprite's single frame dimensions;
    if (w.sprite.height > 0) {
      const ratio = w.sprite.width / w.sprite.height;
      w.item.width = ratio * w.item.height;
    }
    const point = new TimePoint();
    const middlePoint = new TimePoint();
    const endPoint = new TimePoint();
    w.imageUrl = w.sprite.links[0];
    if (!/^\/\/|^http/i.test(w.imageUrl)) {
      w.imageUrl = '//' + w.imageUrl;
    }

    w.item.count = Math.ceil(rectangle.width / w.item.width);
    for (let i = 0, I = w.item.count; i < I; i++) {
      point.set(rectangle.p1.x + i * w.item.width, rectangle.p1.y);
      endPoint.set(point.x + w.item.width, rectangle.p1.y);
      middlePoint.set((point.x + endPoint.x) / 2, rectangle.p1.y);
      point2time(timeRectangles, middlePoint);

      let timeOfFrame = 0;
      if (middlePoint.isValid()) {
        timeOfFrame = middlePoint.time;
      } else {
        point2time(timeRectangles, point);
        timeOfFrame = point.time;
      }

      const time_dx = w.time_0 + Math.abs(timeOfFrame - asset.displayStartTime);
      let frame_index = Math.round(time_dx / w.sprite.sampleIntervalSec);

      // repeat last frame if index is out-of-bounds
      if (frame_index > w.sprite.storyBoardDimensions.x - 1) {
        frame_index = w.sprite.storyBoardDimensions.x - 1;
      }
      const shift = w.item.width * frame_index;

      rv.push(
        new SpriteStyle(endPoint.x - point.x, w.item.height, w.imageUrl, shift)
      );
    }
  } else if (colourCardCss) {
    // wallpaper
    w.item.count = Math.ceil(rectangle.width / w.item.width);
    for (let i = 0, I = w.item.count; i < I; i++) {
      rv.push(
        new ColourCardSpriteStyle(w.item.width, w.item.height, colourCardCss)
      );
    }
  } else {
    detectImage(w, asset);
    if (w.imageUrl) {
      if (!/^\/\/|^http|^\/resources\//i.test(w.imageUrl)) {
        debugger; // why? is it still relevant?
        w.imageUrl = '//' + w.imageUrl;
      }

      w.item.count = Math.ceil(rectangle.width / w.item.width);
      for (let i = 0, I = w.item.count; i < I; i++) {
        rv.push(new ImageSpriteStyle(w.item.width, w.item.height, w.imageUrl));
      }
    }
  }

  return rv;
}

export function getTrackIcon(asset) {
  if (app.assetType.isOnlyIMAGE(asset)) {
    return 'wticon-picture-sun';
  } else if (app.assetType.isVIDEO(asset) || app.assetType.isFRAGMENT(asset)) {
    return 'wticon-camera';
  } else if (app.assetType.isGIF(asset)) {
    return 'wticon-gif_icon';
  } else if (app.assetType.isWALLPAPER(asset)) {
    return 'wticon-Bucket';
  } else if (app.assetType.isWEBPAGE(asset)) {
    return 'wticon-globe';
  } else if (app.assetType.isMAP(asset)) {
    return 'wticon-instagram-location';
  }
}

export function getColourCardCss(wallpaperMetaData) {
  return app.computeBgFromColorData(wallpaperMetaData);
}

export function getAudioResizeWindow(track) {
  const leftMin = track.data.displayStartTime - track.data.relativeStartTime;
  const leftMax = track.data.displayEndTime - track.durationLimits.min;
  const rightMin = track.data.displayStartTime + track.durationLimits.min;
  const rightMax =
    track.durationLimits.max -
    track.data.relativeEndTime +
    track.data.displayEndTime;

  return {
    left: {
      min: leftMin,
      max: leftMax,
    },
    right: {
      min: rightMin,
      max: rightMax,
    },
  };
}

export function getGifSnapTimes(asset) {
  const rv = [];

  if (app.assetType.isGIF(asset)) {
    const duration = fg.trunc(asset.metadata.duration);
    for (let i = 1, I = 10; i <= I; i++) {
      rv.push(fg.trunc(asset.displayStartTime + i * duration));
    }
  }

  return rv;
}

export function getVisualOverlaySnapTimes(pipa, overlay, secondhand) {
  const left = [pipa.scene.displayStartTime, secondhand];
  const right = [pipa.scene.displayEndTime, secondhand];

  for (const o of pipa.track) {
    if (o.guid !== overlay.guid) {
      left.push(pipa.toAbsolute(o.displayEndTime));
      right.push(pipa.toAbsolute(o.displayStartTime));
    }
  }

  return { left, right };
}

export function assetIsExpired(asset) {
  return app.assetType.isExpired(asset);
}

export function getVisualSplitContext(asset, time) {
  const oldDuration = asset.displayDuration;
  const originalDisplayDuration = time - asset.displayStartTime;
  const cloneDisplayDuration = asset.displayEndTime - time;

  const original = {
    displayDuration: originalDisplayDuration,
    displayStartTime: asset.displayStartTime,
    displayEndTime: time,
  };

  if (_.isDefined(asset.startTime)) {
    original.endTime = fg.trunc(
      asset.startTime + originalDisplayDuration * (asset.agd.videoSpeed || 1)
    );
  }

  const clone = {
    displayDuration: cloneDisplayDuration,
    displayStartTime: time,
    displayEndTime: asset.displayEndTime,
  };

  if (_.isDefined(asset.endTime)) {
    clone.startTime = fg.trunc(
      asset.endTime - cloneDisplayDuration * (asset.agd.videoSpeed || 1)
    );
  }

  return {
    oldDuration,
    original,
    clone,
  };
}

export function canSplitVisualAtTime(asset, time) {
  if (
    app.assetType.isINFOGRX(asset)
    // ||
    // app.assetType.isSOCIAL(asset) ||
    // app.assetType.isSOCIALFRAGMENT(asset)
  ) {
    // not relevant for those assets
    return false;
  }

  const context = getVisualSplitContext(asset, time);
  const assetLimitMin = asset.limit.min;
  const originalTime = fg.ceil(
    context.original.displayEndTime - context.original.displayStartTime
  );
  const cloneTime = fg.ceil(
    context.clone.displayEndTime - context.clone.displayStartTime
  );

  return originalTime >= assetLimitMin && cloneTime >= assetLimitMin;
}

export function canSplitAudioAtTime(track, time) {
  const { data, durationLimits } = track;
  const min = fg.ceil(data.displayStartTime + durationLimits.min);
  const max = fg.trunc(data.displayEndTime - durationLimits.min);

  return _.between(min, time, max);
}

/**
 * assign asset.displayDuration using asset.limit.initial with tweaks in the process
 */
export function setDefaultDuration({
  asset,
  programmer,
  isExternal,
  isInSceneEdit,
}) {
  const isImage = app.assetType.isIMAGE(asset);
  const isWallpaper = app.assetType.isWALLPAPER(asset);
  const isSocial = app.assetType.isSOCIAL(asset);
  const isSocialFragment = app.assetType.isSOCIALFRAGMENT(asset);
  const isRelevant = isImage || isWallpaper || (isSocial && !isSocialFragment);

  if (isRelevant) {
    const prevDuration =
      app.namespace.Controller.AssetController.getInitialAssetDuration(asset);

    if (!invalidTime(prevDuration, true) && isExternal) {
      if (isInSceneEdit) {
        asset.limit.initial = programmer.configInitialOverlayImageDT;
      } else {
        asset.limit.initial = prevDuration;
      }
    }
  }

  // if (!_.between(asset.limit.min, asset.limit.initial, asset.limit.max)) {
  //   app.doctorController.report(
  //     'setDefaultDuration->duration exceeding the limits',
  //     null,
  //     {
  //       extra: {
  //         typeIs: app.assetType.is(asset),
  //         limit: asset.limit,
  //       },
  //     }
  //   );
  // }

  asset.displayDuration = fg.trunc(asset.limit.initial);
}

export function setReplacementDuration({ asset, asset2replace }) {
  if (
    app.assetType.isFRAGMENT(asset) ||
    app.assetType.isSOCIALFRAGMENT(asset) ||
    app.assetType.isGIF(asset)
  ) {
    // uses initial duration
    asset.displayDuration = asset.limit.initial;
  } else {
    // inherits replacement duration
    asset.displayDuration = asset2replace.displayDuration;
  }
}

export function getAudioListItem(audio, track) {
  return {
    assetUUID: audio.metadata.assetUUID,
    transcribeSubType: app.transcribeSubType.NARRATION,
    isCurrent: track?.guid === audio.guid,
    timeLimit: {
      startTime: audio.relativeStartTime,
      endTime: audio.relativeEndTime,
      displayStartTime: audio.displayStartTime,
      displayEndTime: audio.displayEndTime,
    },
  };
}

export function getVisualListItem(visual, track) {
  return {
    assetUUID: visual.metadata.assetUUID,
    transcribeSubType: app.transcribeSubType.VIDEO,
    isCurrent: track?.guid === visual.guid,
    timeLimit: {
      startTime: visual.startTime,
      endTime: visual.endTime,
      displayStartTime: visual.displayStartTime,
      displayEndTime: visual.displayEndTime,
    },
  };
}

/**
 * @param visualTracks {Array} - visualsWithExistingTranscript
 * @param audioTracks {Array} - trackLayer.audio..data
 * @param [track]
 * @return {Array}
 */
export function getTranscriptEditableAssets(visualTracks, audioTracks, track) {
  const layer = { visual: [], audio: [] };

  // fill layers according to business logic

  for (let n = 0, N = audioTracks.length; n < N; n++) {
    const audio = audioTracks[n].data;
    layer.audio.push(getAudioListItem(audio, track));
  }

  for (let n = 0, N = visualTracks.length; n < N; n++) {
    const v = visualTracks[n];

    if (!v.agd.showTranscription) {
      continue;
    }

    // omit cause fully inside other audio
    const envelopedByAudio = _.find(layer.audio, ({ timeLimit }) => {
      return (
        _.between(
          timeLimit.displayStartTime,
          v.displayStartTime,
          timeLimit.displayEndTime
        ) &&
        _.between(
          timeLimit.displayStartTime,
          v.displayEndTime,
          timeLimit.displayEndTime
        )
      );
    });

    if (envelopedByAudio) {
      continue;
    }

    // need to split to many items [more than 0] cause many [more than 0] audios under video?
    const envelopedByVideo = _.filter(layer.audio, ({ timeLimit }) => {
      return (
        _.between(
          v.displayStartTime,
          timeLimit.displayEndTime,
          v.displayEndTime
        ) ||
        _.between(
          v.displayStartTime,
          timeLimit.displayStartTime,
          v.displayEndTime
        )
      );
    });

    if (_.isEmpty(envelopedByVideo)) {
      layer.visual.push(getVisualListItem(v, track));
    } else {
      // is there any gap between audio/s and visual asset time limits?
      console.log('envelopedByVideo', envelopedByVideo);
      let cur = envelopedByVideo[0];
      let time = fg.trunc(cur.timeLimit.displayStartTime - v.displayStartTime);
      const gap = {
        start: v.displayStartTime,
        end: null,
        duration() {
          return this.end - this.start;
        },
      };

      if (time > app.TIME.MAX_INTERASSET_CLEARANCE) {
        gap.end = cur.timeLimit.displayStartTime;

        layer.visual.push({
          ...getVisualListItem(v, track),
          timeLimit: {
            startTime: v.startTime,
            endTime: fg.trunc(v.startTime + gap.duration()),
            displayStartTime: gap.start,
            displayEndTime: gap.end,
          },
        });
      }

      let prev = null;
      for (let nn = 1, NN = envelopedByVideo.length; nn < NN; nn++) {
        cur = envelopedByVideo[nn];
        prev = envelopedByVideo[nn - 1];
        time = Math.abs(
          cur.timeLimit.displayStartTime - prev.timeLimit.displayEndTime
        );

        if (time > app.TIME.MAX_INTERASSET_CLEARANCE) {
          gap.start = prev.timeLimit.displayEndTime;
          gap.end = cur.timeLimit.displayStartTime;

          layer.visual.push({
            ...getVisualListItem(v, track),
            timeLimit: {
              startTime: fg.trunc(
                v.startTime + (gap.start - v.displayStartTime)
              ),
              endTime: fg.trunc(
                v.startTime + (gap.start - v.displayStartTime) + gap.duration()
              ),
              displayStartTime: gap.start,
              displayEndTime: gap.end,
            },
          });
        }
      }

      time = fg.trunc(v.displayEndTime - cur.timeLimit.displayEndTime);

      if (time > app.TIME.MAX_INTERASSET_CLEARANCE) {
        gap.start = cur.timeLimit.displayEndTime;
        gap.end = v.displayEndTime;

        layer.visual.push({
          ...getVisualListItem(v, track),
          timeLimit: {
            startTime: fg.trunc(v.startTime + (gap.start - v.displayStartTime)),
            endTime: v.endTime,
            displayStartTime: gap.start,
            displayEndTime: gap.end,
          },
        });
      }
    }
  }

  // fill return value from populated layers
  const rv = [...layer.audio, ...layer.visual];
  rv.sort(
    (a, b) => a.timeLimit.displayStartTime - b.timeLimit.displayStartTime
  );

  return rv;
}

export function getAssetVideoSpeed(asset) {
  let rv = null;
  if (isNumber(asset.agd.videoSpeed) && 1 !== asset.agd.videoSpeed) {
    rv = `x${asset.agd.videoSpeed}`;
  }
  return rv;
}

export function isVisualAssetMuted(asset, hasAudio) {
  if (!asset.hasValidAudio || getAssetVideoSpeed(asset)) {
    return true;
  } else if (hasAudio) {
    return (
      asset.volumeControl.video === 0 && asset.onVoPlayVolumeControl.video === 0
    );
  } else {
    return asset.volumeControl.video === 0;
  }
}

/**
 * Return audio tracks between times
 * Get all audio tracks that are bellow visual track
 * @param startTime {{Number}}
 * @param endTime {{Number}}
 * @param audioLayer {{Array}}
 * @returns {Array<AudioTrackWrapper>}
 */
export function getAudioTracksBetweenSpan({ startTime, endTime, audioLayer }) {
  const rv = [];

  for (let n = 0, N = audioLayer.length; n < N; n++) {
    const audio = audioLayer[n];

    if (audio.data.displayStartTime > endTime) {
      break;
    }
    if (
      _.between(startTime, audio.data.displayEndTime, endTime, {
        includeMin: false,
      }) ||
      _.between(startTime, audio.data.displayStartTime, endTime, {
        includeMax: false,
      }) ||
      _.between(
        audio.data.displayStartTime,
        startTime,
        audio.data.displayEndTime,
        { includeMax: false }
      )
    ) {
      rv.push(audio);
    }
  }

  return rv;
}
